import axios from "axios";
import { getApiUrl, getApiHeader } from "utils";

export const getBankByIfsc = (payload) => {
  return axios.post(
    `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_verification.api.get_bank_details`,
    payload,
    getApiHeader()
  );
};


export const getReKycBankByIfsc = (payload) => {
  return axios.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_bank_details`,
    payload,
    getApiHeader()
  );
};
